import React from "react";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";
import {
  BreitenEingabe,
  breitenEingabeLabel,
  HöhenEingabe,
  StandardMassInfoRow,
} from "../ElementSizeComponents";

export function ZaunCircleMenuItemElementSize() {
  const agt = APP.arrangement;
  const object = agt.selectedObjects[0];

  if (!(object?.isElement || object?.isEmpty)) return null;

  return (
    <ZaunCircleMenuItem
      className={"onTop"}
      dataButtonKey={I18N("aria::Elementgröße anpassen")}
      onClick={(event: any) => {
        event.stopPropagation();
        const input = (event.target as HTMLDivElement).querySelector("input");
        input && input.focus();
      }}
    >
      <div className="flex-column">
        <div className="flex-row align-items-center">
          {breitenEingabeLabel(object)}
          <BreitenEingabe object={object} />
          {object.isElement ? (
            <>
              &nbsp;&nbsp; x &nbsp;&nbsp;
              {I18N("Höhe")}
              <HöhenEingabe object={object} />
            </>
          ) : null}
        </div>
        <StandardMassInfoRow object={object} />
      </div>
    </ZaunCircleMenuItem>
  );
}
